import React, { useRef } from "react";
import { useOnScreen } from "./useOnScreen";
import { scrollToAnchor } from "./Service";

export const NewPrizes = ({ content, lang }) => {
  const imgsRef = useRef(null);
  const fadeAlready = useOnScreen(imgsRef, "fade-already");

  return (
    <div className="new-prizes-wrapper">
      <h1 className="new-prizes-title">{content.title}</h1>
      <p className="new-prizes-subtitle">{content.subtitle}</p>
      <div className="new-prizes-content">
        <div className={`small-imgs ${fadeAlready}`} ref={imgsRef}>
          {content.prizes.map((img, index) => (
            <div
              className={`small-img small-img-${index}`}
              key={index}
              style={{ animationDelay: `${200 * index}ms` }}
            >
              <img src={img} />
            </div>
          ))}
        </div>
        <div className={`new-prizes-bottom ${lang}`}>
          <h1 className="new-prizes-bottom-title">{content.bottom_title}</h1>
          <p className="new-prizes-bottom-subtitle">
            {content.bottom_subtitle}
          </p>
          <p
            className="new-prizes-bottom-highlight"
            style={{ color: "#69f0ae" }}
          >
            {content.bottom_highlight}
          </p>
          <button
            className={`spin-btn`}
            onClick={() => scrollToAnchor("spin-wheel")}
          >
            {content.spin_now}
          </button>
        </div>
      </div>
    </div>
  );
};
